<template>
  <div id="btnsWrap">
    <ul>
      <li :style="frameStyle" v-for="item in ansData" :key="item.btnTxt">
        <div class="inr" v-html="item.btnTxt" @click="onClickAns"></div>
        <div class="arrow" v-if="btnNum === 1" :style="arrowStyle"></div>
      </li>
    </ul>
  </div>
</template>

<script>
  import _$ from 'jquery'
  // import _ from 'lodash'

  export default {
    name: 'AnsBtnSet',
    props: {
      // ansData: Array
    },
    data() {
      return {
        normalStyle: {
          backgroundImage: 'url(./img/common/pink_frm02_358_t.png),url(./img/common/pink_frm02_358_b.png), url(./img/common/pink_frm02_l.png), url(./img/common/pink_frm02_r.png)',
        },
        onlyStyle: {
          backgroundImage: 'url(./img/common/pink_frm02_724_t.png),url(./img/common/pink_frm02_724_b.png), url(./img/common/pink_frm02_l.png), url(./img/common/pink_frm02_r.png)',
        },
        frameStyle: {},
        arrowStyle: { backgroundImage: 'url(./img/common/white_arw.png)' },
        btnNum: null,
        ansData: null,
        timer: null
      }
    },
    mounted() {
      this.updateAnsData()
    },
    destroyed() {
      this.stopTimer()
    },
    watch: {    
      ansData(newValue) {
        this.stopTimer()
        if(newValue){
          this.btnNum = newValue.length
          switch(this.btnNum){
            case 1:
              this.frameStyle = this.onlyStyle
              this.blinkArrow()
              break
            default: {
              this.frameStyle = this.normalStyle
            }
          }
        }
      }
    },
    methods: {
      updateAnsData(){
        this.ansData = this.$parent.ansBtns
      },
      onClickAns(e){
        let ansVal = _$('#btnsWrap ul li').index(_$(e.target).parents('li'));
        this.$emit('selectAns', ansVal);
      },
      blinkArrow: function(){
        this.timer = setInterval(function(){
          _$('#btnsWrap ul li .arrow').toggle()
        }.bind(this), 500)
      },
      stopTimer: function(){
        clearInterval(this.timer)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #btnsWrap {
    margin: toVW(32) toVW(13) toVW(13);
    display: flex;
    justify-content: center;

    ul {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;

      li {
        background-position: top center, bottom center, left top, right top;
        background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
        background-size: 100% auto, 100% auto, toVW(15) auto, toVW(15) auto;
        width: toVW(358);
        height: toVW(156);
        position: relative;
        line-height: 1.5;
        letter-spacing: 0.05em;

        &:nth-child(odd){
          margin-right: toVW(8);
        }

        &:nth-child(n+3){
          margin-top: toVW(8);
        }

        .inr {
          width: 100%;
          height: 100%;
          padding: toVW(40) toVW(40) toVW(40) toVW(70);
          position: relative;

          &::before {
            position: absolute;
            top: toVW(40);
            left: toVW(40);
          }
        }
        
        &:nth-child(1) {
          .inr {
            &::before {
              content: "A.";
            }
          }
        }
        &:nth-child(2) {
          .inr {
            &::before {
              content: "B.";
            }
          }
        }
        &:nth-child(3) {
          .inr {
            &::before {
              content: "C.";
            }
          }
        }
        &:nth-child(4) {
          .inr {
            &::before {
              content: "D.";
            }
          }
        }

        &:only-child {
          background-size: toVW(724) auto, toVW(724) auto, toVW(15) auto, toVW(15) auto;
          width: toVW(724);

          .inr {
            display: flex;
            align-items: center;
            justify-content: center;

            &::before {
              content: none;
            }
          }
        }

        .arrow {
          background-repeat: no-repeat;
          background-size: contain;
          width: toVW(21);
          height: toVW(28);
          position: absolute;
          top: calc((100% - 3.733vw) / 2);
          left: toVW(37);
          display: none;
        }
      }
    }
  }
</style>
